import * as React from "react";
import { CmsPageLayout } from "@grandvisionhq/bloomreach";
function withCmsLayout(settings = {}) {
  return (layout = {}) => (PageComponent) => {
    const WithCmsLayout = (props) => {
      const Wrapper = !props.isContentPage ? CmsPageLayout : React.Fragment;
      return /* @__PURE__ */ React.createElement(Wrapper, { ...settings, layoutSettings: layout }, /* @__PURE__ */ React.createElement(PageComponent, { ...props }));
    };
    if (typeof PageComponent.getInitialProps === "function") {
      WithCmsLayout.getInitialProps = PageComponent.getInitialProps;
    }
    if (process.env.NODE_ENV !== "production") {
      const displayName = PageComponent.displayName || PageComponent.name || "Unknown";
      WithCmsLayout.displayName = `WithCmsLayout(${displayName})`;
    }
    return WithCmsLayout;
  };
}
export {
  withCmsLayout
};
//# sourceMappingURL=with-cms-layout.js.map
